const doc = [({"en":({"js":({"admin":({"contacts":({"relations":({"relationship_was_removed":"Relationship was removedd"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;